import { ForwardedRef, forwardRef, memo, useCallback, useMemo } from 'react';
import { zIndex as cdsZIndex } from '@cbhq/cds-common/tokens/zIndex';
import { Box } from '@cbhq/cds-web/layout';
import { spacing } from '@cbhq/cds-web/tokens';
import { TextLabel2 } from '@cbhq/cds-web/typography';

import { PopperFlyoutProps } from './FlyoutProps';

export const FlyoutContent = memo(
  forwardRef(
    (
      { content, gap, testID, zIndex, flyoutId, onClick }: PopperFlyoutProps,
      ref: ForwardedRef<HTMLDivElement>,
    ) => {
      const outerStyle = useMemo(
        () => ({
          padding: spacing[gap],
          zIndex: zIndex ?? cdsZIndex.overlays.tooltip,
        }),
        [gap, zIndex],
      );

      const handleOnClick = useCallback(() => {
        onClick?.();
      }, [onClick]);

      return (
        <Box style={outerStyle} onClick={handleOnClick}>
          <Box
            bordered
            elevation={2}
            ref={ref}
            spacingHorizontal={0}
            spacingVertical={0}
            background="background"
            borderRadius="roundedLarge"
            maxWidth={368}
            testID={testID}
          >
            {typeof content === 'string' ? (
              <TextLabel2 as="p" overflow="break" id={flyoutId} accessibilityLabel={content}>
                {content}
              </TextLabel2>
            ) : (
              <div id={flyoutId}>{content}</div>
            )}
          </Box>
        </Box>
      );
    },
  ),
);
